import * as tslib_1 from "tslib";
import { BaseManager } from "./base.manager";
import { LocalStorageRepositoryInterface } from "../../datastore/local/localstorage.interface";
import { EmployeeRepositoryInterface } from "app/datastore/repositories/employee/employee.interface";
var EmployeeManager = /** @class */ (function (_super) {
    tslib_1.__extends(EmployeeManager, _super);
    function EmployeeManager(localStorageRepository, employeeRepository) {
        var _this = _super.call(this, localStorageRepository) || this;
        _this.localStorageRepository = localStorageRepository;
        _this.employeeRepository = employeeRepository;
        return _this;
    }
    EmployeeManager.prototype.createEmployee = function (employee) {
        return this.employeeRepository.createEmployee(employee);
    };
    EmployeeManager.prototype.editEmployee = function (id, employee) {
        return this.employeeRepository.editEmployee(id, employee);
    };
    EmployeeManager.prototype.deleteEmployee = function (id) {
        return this.employeeRepository.deleteEmployee(id);
    };
    return EmployeeManager;
}(BaseManager));
export { EmployeeManager };
